import { ViewModel,View, ObservableArray } from "binder"
import  { ProductBalanceBatchView } from "./productBalanceBatch-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { WarehouseMultiSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile } from "src/uicomponents/components/utilities";

export class ProductBalanceBatchViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'موجودی دسته ای';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<item>();
        this.warehouseSelector = new WarehouseMultiSelectorViewModel(this, true);

    }
    GetDefaultView(): View <ViewModel> {
        return new ProductBalanceBatchView();
    }
    public getTypeId(): string {
        return "VM-32B5E335-CC70-4E9E-90B2-CF0F1E67FD0F"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set fromCode(v: string) { this._fromCode = v; } public get fromCode(): string { return this._fromCode;} private _fromCode: string;
    public set toCode(v: string) { this._toCode = v; } public get toCode(): string { return this._toCode;} private _toCode: string;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    
    public set warehouseSelector(v: WarehouseMultiSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseMultiSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseMultiSelectorViewModel;
    

    async refresh() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetProductBalancesBatch',{
                CodeFrom : this.fromCode,
                CodeTo : this.toCode,
                WarehouseIds : this.warehouseSelector.selectedItems.map(x=>x.id),
                RequireExcel : false
            });
            this.items.update(...result.Products.map((x,i)=>{
                let r = new item(this);
                r.index = i+1;
                r.id = x.MeasuredProductId;
                r.code = x.PartNumber;
                r.name = x.PartName;
                r.productIndex = x.ProductIndex;
                r.productCarModel = x.ProductCarModel;
                r.balance = x.Amount;
                r.location = x.Location;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async exportExcel(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetProductBalancesBatch',{
                CodeFrom : this.fromCode,
                CodeTo : this.toCode,
                WarehouseIds : this.warehouseSelector.selectedItems.map(x=>x.id),
                RequireExcel : true
            });
            downloadFile(result.ExcelData,'موجودی دسته ای.xlsx');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }

    }
}

export class item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set productIndex(v: string) { this._productIndex = v; } public get productIndex(): string { return this._productIndex;} private _productIndex: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set location(v: string) { this._location = v; } public get location(): string { return this._location;} private _location: string;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance;} private _balance: number;

}
